/**
 * TrainingStatusBadge
 *
 * Status pill for training status (required vs optional, completed/overdue/expired).
 * Mantine Badge with TrainingStatusLabels and TrainingStatusColors.
 * Medplum StatusBadge is for FHIR resource statuses; we use custom for training lifecycle.
 */

import { Badge } from '@mantine/core';
import type { TrainingStatus } from '../types';
import { TrainingStatusLabels, TrainingStatusColors } from '../types';

interface TrainingStatusBadgeProps {
  status: TrainingStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function TrainingStatusBadge({ status, size = 'sm' }: TrainingStatusBadgeProps): JSX.Element {
  return (
    <Badge size={size} variant="light" color={TrainingStatusColors[status]}>
      {TrainingStatusLabels[status]}
    </Badge>
  );
}
